/**
 * Shimmer placeholder for a campaign list row. Mirrors the CampaignCard
 * layout (70x70 thumbnail + title / product / stats stack) so the loading
 * state doesn't shift when real cards swap in. Render `count` of these while
 * the campaigns query is in flight.
 */
export default function CampaignCardSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bmc-card"
          style={{
            borderRadius: 12,
            padding: 16,
            display: 'flex',
            alignItems: 'center',
            gap: 14,
          }}
        >
          {/* thumbnail */}
          <div
            className="skeleton"
            style={{ width: 70, height: 70, borderRadius: 8, flexShrink: 0 }}
          />
          {/* text stack */}
          <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <div className="skeleton" style={{ width: '38%', height: 16, borderRadius: 6 }} />
            <div className="skeleton" style={{ width: '55%', height: 13, borderRadius: 6 }} />
            <div className="skeleton" style={{ width: '46%', height: 13, borderRadius: 6 }} />
          </div>
          {/* trailing action */}
          <div
            className="skeleton"
            style={{ width: 32, height: 32, borderRadius: 8, flexShrink: 0 }}
          />
        </div>
      ))}
    </div>
  )
}
